import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/menu/top-logo.png'
import _imports_1 from '@/assets/images/menu/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-9ed16f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-menu-container" }
const _hoisted_2 = { class: "padding-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%"},
  alt: "neco fun"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "bottom-section" }
const _hoisted_6 = { class: "lang-row" }
const _hoisted_7 = { class: "btn-content" }
const _hoisted_8 = { class: "balance-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1,
  alt: "neco fun"
}, null, -1))
const _hoisted_10 = { class: "balance" }
const _hoisted_11 = { class: "contact-row" }
const _hoisted_12 = { class: "contact-list" }
const _hoisted_13 = ["onClick", "title"]

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Menu, menuList } from '@/configs/menus';
import i18n, { getDefaultLang, languages } from '@/language/i18n';
import { Contact, contactList } from '@/configs/contacts';
import { useStore } from '@/store';
import { MutationCommands } from '@/store/mutations';
import { currentEnvironment, ProjectEnvironment } from '@/common/project-environment';
import { getNECOTokenPrice } from '@/common/contracts/apis/neco-token-api';
import Tools from '@/common/tools';


export default /*#__PURE__*/_defineComponent({
  emits: ['menu-clicked'],
  setup(__props, { emit }) {

const store = useStore();


const isCollapse = ref(false);

const router = useRouter();

const lang = ref(getDefaultLang());
function changeLang(val: string) {
  lang.value = val;
  i18n.global.locale = val as any;
  store.commit(MutationCommands.SET_LANG, val);
}

const activePageName = ref('Home');

function menuClick(menu: Menu) {
  emit('menu-clicked');
  if (!menu.isOpen) {
    window.alert('Coming Soon.');
    return;
  }

  activePageName.value = menu.name;
  router.push({ path: menu.router || '/' });
}

function backHomePage() {
  router.push('/');
  activePageName.value = '';
}

const price = ref('0');
const necoPrice = () => {
  getNECOTokenPrice().then((result) => {
    console.log(`------${result}`);
    price.value = Number(result).toFixed(2);
  });
};

onMounted(() => {
  if (currentEnvironment() === ProjectEnvironment.Development) {
    console.log('This is dev env');
  } else {
    console.log('this is prod evn');
  }
  necoPrice();
});

function contactUs(item: Contact) {
  if (item.link) window.open(item.link);
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "header-logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (backHomePage()))
      }, _hoisted_4),
      _createVNode(_component_el_menu, {
        "default-active": "home",
        class: "el-menu-vertical",
        collapse: isCollapse.value
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (menu) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (menu.children && menu.children.length)
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: menu.name,
                    index: menu.name
                  }, {
                    title: _withCtx(() => [
                      (menu.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass([menu.icon, "iconfont"])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(menu.trans || menu.name)), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (subMenu) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          class: _normalizeClass({ active: activePageName.value === subMenu.name }),
                          key: subMenu.name,
                          index: subMenu.name,
                          disabled: !subMenu.isOpen,
                          onClick: ($event: any) => (menuClick(subMenu))
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(subMenu.trans || subMenu.name)), 1)
                          ]),
                          default: _withCtx(() => [
                            (subMenu.icon)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass([subMenu.icon, "iconfont"])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class", "index", "disabled", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : (_openBlock(), _createBlock(_component_el_menu_item, {
                    class: _normalizeClass({ active: activePageName.value === menu.name }),
                    key: menu.name,
                    index: menu.name,
                    disabled: !menu.isOpen,
                    onClick: ($event: any) => (menuClick(menu))
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t(menu.trans || menu.name)), 1)
                    ]),
                    default: _withCtx(() => [
                      (menu.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass([menu.icon, "iconfont"])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class", "index", "disabled", "onClick"]))
            ], 64))
          }), 256))
        ]),
        _: 1
      }, 8, ["collapse"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_dropdown, {
          trigger: "hover",
          style: {"margin-right":"30px"}
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: lang.code,
                    onClick: ($event: any) => (changeLang(lang.code))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(lang.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { class: "white-btn" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(lang.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, "$" + _toDisplayString(price.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name,
              class: "contact-item",
              onClick: ($event: any) => (contactUs(item)),
              title: item.name
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["icon iconfont", item.icon])
              }, null, 2)
            ], 8, _hoisted_13))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})